import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-file',
  templateUrl: './icon-file.component.html',
  styleUrls: ['./icon-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFileComponent {}
